import PageLoader from 'components/common/PageLoader';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, RouteProps, useHistory, useLocation } from 'react-router-dom';
import { isUserLoggedIn } from 'store/auth/selectors';

const ProtectedRoute = (props: RouteProps) => {
  const history = useHistory();
  const location = useLocation();
  const loggedIn = useSelector(isUserLoggedIn);

  useEffect(() => {
    if (!loggedIn) {
      // Encode the full path as a query param so it survives full page navigations
      const currentPath = `${location.pathname}${location.search}`;
      const encoded = encodeURIComponent(currentPath);

      history.replace(`/auth?redirect=${encoded}`);
    }
  }, [loggedIn, history, location]);

  if (!loggedIn) {
    return <PageLoader />;
  }

  return <Route {...props} />;
};

export default ProtectedRoute;
